import { render, staticRenderFns } from "./CardTicketDescription.vue?vue&type=template&id=13164e68"
import script from "./CardTicketDescription.vue?vue&type=script&lang=js"
export * from "./CardTicketDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports